__turbopack_context__.v({
  "actions": "B6QQOq_actions",
  "backToLoginBtn": "B6QQOq_backToLoginBtn",
  "bottom": "B6QQOq_bottom",
  "desc": "B6QQOq_desc",
  "email": "B6QQOq_email",
  "emailInput": "B6QQOq_emailInput",
  "emailWrapper": "B6QQOq_emailWrapper",
  "forgotPasswordForm": "B6QQOq_forgotPasswordForm",
  "form": "B6QQOq_form",
  "header": "B6QQOq_header",
  "heading": "B6QQOq_heading",
  "img__aeFzs": "B6QQOq_img__aeFzs",
  "img__e7Nxd": "B6QQOq_img__e7Nxd",
  "label": "B6QQOq_label",
  "line": "B6QQOq_line",
  "link": "B6QQOq_link",
  "link__rfVAo": "B6QQOq_link__rfVAo",
  "loginFormResources": "B6QQOq_loginFormResources",
  "loginFormSecurity": "B6QQOq_loginFormSecurity",
  "logo": "B6QQOq_logo",
  "resetPassword": "B6QQOq_resetPassword",
  "resetPasswordBtn": "B6QQOq_resetPasswordBtn",
  "root": "B6QQOq_root",
  "section": "B6QQOq_section",
  "serviceMessage": "B6QQOq_serviceMessage",
  "spinnerIcon": "B6QQOq_spinnerIcon",
  "svg___3L40Z": "B6QQOq_svg___3L40Z",
  "svg___8DCc0": "B6QQOq_svg___8DCc0",
  "svg___90Pl": "B6QQOq_svg___90Pl",
  "svg__obP09": "B6QQOq_svg__obP09",
  "svg__so0Yn": "B6QQOq_svg__so0Yn",
  "text___38MSa": "B6QQOq_text___38MSa",
  "text__ydY34": "B6QQOq_text__ydY34",
  "title": "B6QQOq_title",
  "wrapper": "B6QQOq_wrapper",
});
